/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't decide? Enter your options, one per line, and spin the wheel to pick one at random. Great for choosing what to eat, picking a name or settling any tie.`)
};

const es_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No te decides? Introduce tus opciones, una por línea, y gira la rueda para elegir una al azar. Ideal para elegir qué comer, escoger un nombre o resolver cualquier empate.`)
};

const de_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kannst du dich nicht entscheiden? Gib deine Optionen ein, eine pro Zeile, und drehe das Rad, um zufällig eine auszuwählen. Ideal, um zu entscheiden, was es zu essen gibt, einen Namen auszuwählen oder ein Unentschieden zu klären.`)
};

const nl_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun je niet kiezen? Vul je opties in, één per regel, en draai aan het rad om er willekeurig één te kiezen. Ideaal om te bepalen wat je gaat eten, een naam te kiezen of elke onbeslissing te doorbreken.`)
};

const fr_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'arrivez pas à choisir ? Saisissez vos options, une par ligne, et faites tourner la roue pour en choisir une au hasard. Idéal pour choisir quoi manger, tirer un nom ou trancher n'importe quelle égalité.`)
};

const it_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non riesci a decidere? Inserisci le tue opzioni, una per riga, e fai girare la ruota per sceglierne una a caso. Ottima per decidere cosa mangiare, scegliere un nome o risolvere qualsiasi indecisione.`)
};

const pt_br2_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não consegue decidir? Informe suas opções, uma por linha, e gire a roleta para sortear uma aleatoriamente. Ótima para escolher o que comer, sortear um nome ou resolver qualquer empate.`)
};

const pt_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não consegue decidir? Introduza as suas opções, uma por linha, e gire a roda para escolher uma ao acaso. Ótimo para escolher o que comer, um nome ou resolver qualquer empate.`)
};

const ja_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`決められないときは、選択肢を1行ずつ入力してホイールを回し、ランダムに1つを選びましょう。何を食べるか決めたり、名前を選んだり、あらゆる迷いを解消するのに便利です。`)
};

const zh_dw_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法决定？输入你的选项，每行一个，转动转盘随机选出一个。非常适合决定吃什么、抽取名字或解决任何僵局。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_intro", locale)
	if (locale === "en") return en_dw_intro(inputs)
	if (locale === "es") return es_dw_intro(inputs)
	if (locale === "de") return de_dw_intro(inputs)
	if (locale === "nl") return nl_dw_intro(inputs)
	if (locale === "fr") return fr_dw_intro(inputs)
	if (locale === "it") return it_dw_intro(inputs)
	if (locale === "pt-BR") return pt_br2_dw_intro(inputs)
	if (locale === "pt") return pt_dw_intro(inputs)
	if (locale === "ja") return ja_dw_intro(inputs)
	return zh_dw_intro(inputs)
};